import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setupAxiosInterceptor } from "../utils/axiosInterceptor";

interface Props {
  setSnackbar: any;
}

/**
 * Component to setup axios interceptors for token expiration checking
 * Must be rendered inside BrowserRouter to use useNavigate
 */
const AuthWrapper: React.FC<Props> = ({ setSnackbar }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleTokenExpired = () => {
      setSnackbar({
        isOpen: true,
        message: "Your session has expired. Please login again.",
        type: "error",
      });
      navigate("/", { replace: true });
    };

    // Setup axios interceptors
    setupAxiosInterceptor(handleTokenExpired);
  }, [navigate, setSnackbar]);

  return null;
};

export default AuthWrapper;
